import React from 'react';
import {
  Button,
  Card,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  LargeHeader,
  Paragraph,
  SectionHeader,
} from '@axiom/ui';

export type AvailabilityPreferencesViewProps = {
  name?: string;
};

export const AvailabilityPreferencesView = ({
  name = 'AVAILABILITY_PREFERENCES_VIEW',
}: AvailabilityPreferencesViewProps) => {
  return (
    <Layout direction="vertical" position="middle center" name={name}>
      <LayoutItem>
        <Card name="CARD">
          <CardSection>
            <Layout direction="vertical">
              <LayoutItem position="center">
                <LargeHeader name="THANK_YOU_HEADER">Thank You</LargeHeader>
              </LayoutItem>

              <Gutter bottom="10px" />

              <LayoutItem position="center">
                <SectionHeader name="CONFIRMATION_MESSAGE">
                  You have confirmed that your preferences are up to date.
                </SectionHeader>
              </LayoutItem>

              <Gutter bottom="30px" />

              <LayoutItem position="center">
                <Paragraph name="REVIEW_PROFILE_TEXT">
                  This might be a good time to review your Axiom for Talent
                  profile.
                </Paragraph>
              </LayoutItem>

              <Gutter bottom="16px" />

              <LayoutItem position="center">
                <Button
                  name="SIGN_IN_BUTTON"
                  onClick={() => {
                    window.location.assign('/');
                  }}
                >
                  Sign In
                </Button>
              </LayoutItem>

              <Gutter bottom="16px" />

              <LayoutItem position="center">
                <Paragraph name="CLOSE_WINDOW_TEXT">
                  If you're all done here, you can close this window.
                </Paragraph>
              </LayoutItem>
            </Layout>
          </CardSection>
        </Card>
      </LayoutItem>
    </Layout>
  );
};
